import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Alert, Stack, Typography } from '@mui/material';

import usePromoAdminPermission from '~/components/Promo/hooks/usePromoPermission';

import {
  type VoucherUserExpiryLongDurationMode,
  isVoucherUserExpiryOverTwelveMonths,
} from '~/utils/voucherUserExpiryLongDuration';

type Props = {
  mode: VoucherUserExpiryLongDurationMode;
  voucherUserExpiresAt: string;
  voucherUserExpiresInDays: string;
};

export default function VoucherLongExpiryPromoAdminAlert({
  mode,
  voucherUserExpiresAt,
  voucherUserExpiresInDays,
}: Props) {
  const isPromoAdmin = usePromoAdminPermission();
  const show = isVoucherUserExpiryOverTwelveMonths({
    mode,
    voucherUserExpiresAt,
    voucherUserExpiresInDays,
  });

  if (!show) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ alignItems: 'center', py: 0.75 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography variant="body2" component="span">
          The <strong>promo-admin</strong> permission is required to create a long-lasting voucher.
        </Typography>
        {isPromoAdmin ? (
          <CheckCircleIcon color="success" fontSize="small" aria-label="You have the promo-admin role" />
        ) : (
          <CancelIcon color="error" fontSize="small" aria-label="You do not have the promo-admin role" />
        )}
      </Stack>
    </Alert>
  );
}
